import ColorfulTextArea from './colorful-textarea';
export default ColorfulTextArea;
